<template>
  <FormGroup :error-container="errorContainerName" label="Marital Status" name="maritalStatus" :floating="floating">
    <FmSelect :value="value" :options="options" :icons="icons" :disabled="disabled"
              @input="$emit('input', $event)"/>
  </FormGroup>
</template>

<script>
import ServerErrorMixin from '@modules/shared/mixins/ServerErrorMixin';
import FormGroup from '@modules/shared/components/form/FormGroup.vue';
import FmSelect from '@modules/shared/components/form/FmSelect.vue';
import {MaritalStatus} from '@modules/guest/new-applicant/constants.js';

const ICONS = {
  Single:    `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4z"/></svg>`,
  Defacto:   `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/></svg>`,
  Married:   `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/></svg>`,
  Separated: `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"/></svg>`,
  Divorced:  `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8.931.586 7 3l1.5 4-2 3L8 15C22.534 5.396 13.944-2.212 8.931.586zM7.358.77 5.5 3 7 7l-1.5 3 1.815 4.537C-6.533 4.96 2.356-2.188 7.358.77z"/></svg>`,
  Widowed:   `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/></svg>`,
};

export default {
  name: 'MaritalStatusSelect',
  components: { FormGroup, FmSelect },
  model: { prop: 'value', event: 'input' },
  mixins: [ServerErrorMixin],
  props: {
    value:         { default: '' },
    disabled:      { default: false },
    errorContainer:{ default: '' },
    floating:      { type: Boolean, default: false },
  },
  computed: {
    options: () => MaritalStatus,
    icons:   () => ICONS,
  },
  watch: {
    errorContainer: {
      immediate: true,
      handler(container) { if (container) this.registerErrorContainer(container); },
    },
  },
};
</script>
